import BaseService from '@/services/api/BaseService';
import {
    RealtimeReportServiceGetUserDevicesResult,
    RealtimeReportServiceGetQueueCallsStateResult,
} from '@/types';
import { AxiosRequestConfig } from 'axios';

class RealtimeReportService extends BaseService<unknown> {
    getUserDevices(config?: AxiosRequestConfig) {
        return this.http.get<RealtimeReportServiceGetUserDevicesResult[]>(
            `${this.route}/user-devices-state`,
            config,
        );
    }
    getQueueCallsState(config?: AxiosRequestConfig) {
        return this.http.get<RealtimeReportServiceGetQueueCallsStateResult[]>(
            `${this.route}/queue-calls-state`,
            config,
        );
    }
    toggleQueueMemberPause(userId: number, config?: AxiosRequestConfig) {
        return this.http.post(`${this.route}/${userId}/toggle-pause`, undefined, config);
    }
}

export default new RealtimeReportService('reports/realtime');
